import {API} from '../API';
import PaginatedList from '../PaginatedList';
import Country from '../../models/Country';

const countries = {
    get: async (filters = {}) => {
        const {data: response} = await API.get('/countries', {params: filters});

        const list = new PaginatedList();

        list.items = response.data.map((country) => new Country(country));
        list.page = response.meta.page;
        list.pageSize = response.meta.perPage;
        list.total = response.meta.total;

        return list;
    },
    getAll: async () => {
        const {data: response} = await API.get('/countries/all');

        return {
            countries: response.data.map((country) => new Country(country)),
        };
    },
    detail: async (id) => {
        const {data: response} = await API.get(`/countries/${id}`);

        return {country: new Country(response.data)};
    },
    save: async (input) => {
        await API.post('/countries', input);

        return {};
    },
    update: async (id, input) => {
        await API.put(`/countries/${id}`, input);

        return {};
    },
    delete: async (id) => {
        await API.delete(`/countries/${id}`);

        return {};
    },
    activate: async (id) => {
        await API.put(`/countries/${id}/activate`);

        return {};
    },
    deactivate: async (id) => {
        await API.put(`/countries/${id}/deactivate`);

        return {};
    },
};

export default countries;
